import type { RootState } from '~/store';

// Base selector
export const clanTasksSelector = (state: RootState) => state.ReducerClanTasks;

export const clanTasksIsFetchingSelector = (state: RootState) => state.ReducerClanTasks.isFetching;
export const clanTasksIsClaimingSelector = (state: RootState) => state.ReducerClanTasks.isClaiming;
export const clanTasksClaimedSelector = (state: RootState) => state.ReducerClanTasks.claimed;
export const clanTasksTasksSelector = (state: RootState) => state.ReducerClanTasks.tasks;
